.ux-iws-load-more {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 30px auto;

    &--right {
        justify-content: flex-start;
    }

    &--left {
        justify-content: flex-end;
    }

    &--hidden {
        display: none;
    }

    &__loading {
        margin-top: -30px;
        margin-bottom: 20px;
    }

    &__error {
        display: none;
        margin-bottom: 20px;

        &--active {
            display: block;
        }
    }

    button:focus {
        outline: none;
    }
}
